/*
 * @Description:
 * @Author: xiawenlong
 * @Date: 2021-04-30 11:46:54
 * @LastEditors: xiawenlong
 * @LastEditTime: 2021-11-29 16:01:53
 */
import Vue from "vue";
import ElementUI from "element-ui";
import "@/style/element-color/index.css";
import App from "./App";
import store from "./vuex/store";
import router from "./router";
import "@/api/http.js";
import "@/style/base.css";
import { getCookie } from "@/utils/cookies";
import WebIM from "@/utils/WebIM";
import VueCropper from "vue-cropper";
import VueClipboard from "vue-clipboard2";

// 只对 Chrome/Edge 之类浏览器处理，Safari 不建议这样做
const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

let rawCanPlayType = null;

if (!isSafari) {
  rawCanPlayType = HTMLMediaElement.prototype.canPlayType;

  HTMLMediaElement.prototype.canPlayType = function (type) {
    const t = String(type || '').toLowerCase();

    // 禁止浏览器向播放器声明"我可以原生播放 HLS"
    if (
      t.includes('application/vnd.apple.mpegurl') ||
      t.includes('application/x-mpegurl') ||
      t.includes('mpegurl') ||
      t.includes('m3u8')
    ) {
      return '';
    }

    return rawCanPlayType.call(this, type);
  };
}

Vue.use(VueClipboard);
Vue.use(VueCropper);
import MetaInfo from "vue-meta-info";
Vue.use(MetaInfo);
ElementUI.Dialog.props.lockScroll.default = false;
Vue.config.productionTip = false;
Vue.use(ElementUI);
router.beforeEach((to, from, next) => {
  document.querySelector(".el-main") &&
    document.querySelector(".el-main").scrollTo(0, 0);
  if (to.meta.role) {
    // 判断该路由是否需要登录权限
    if (getCookie("myToken")) {
      // 判断缓存里面是否有   //在登录的时候设置它的值
      next();
    } else {
      ElementUI.Message({
        message: "请先登录",
        type: "warning"
      });
      next({
        path: "/index"
      });
    }
  } else {
    next();
  }
});
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  WebIM,
  components: {
    App
  },
  template: "<App/>",
  data: {
    eventHub: new Vue()
  },
  mounted() {
    document.dispatchEvent(new Event("render-event"));
  }
});



// WEBPACK FOOTER //
// ./src/main.js